import axios from "axios";

export default {
  namespaced: true,
  state: {
    menus: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    menusMessage: ''
  },
  mutations: {
    RECEIVED_MENUS(state, payload) {
      state.menus = payload;
      state.isReceiving = false;
    },
    RECEIVING_MENUS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MENU(state, payload) {
      state = Object.assign(state, {
        menus: [...state.menus, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MENU(state) {
      state.isReceiving = true;
    },
    UPDATED_MENU(state, payload) {
      let index = state.menus.findIndex(menu => menu._id === payload._id);
      state = Object.assign(state, {
        menus: state.menus.map((menu, i) => {
          if (i === index) {
            return Object.assign({}, menu, payload);
          }
          return menu;
        }),
        isUpdating: false,
        menusMessage: 'Menus has been updating!',
      })
    },
    UPDATING_MENU(state) {
      state.isUpdating = true;
    },
    DELETED_MENU(state, payload) {
      let indexToDelete = state.menus.findIndex(menu => menu._id === payload._id);
      let menus = [...state.menus];
      menus.splice(indexToDelete, 1);
      state = Object.assign(state, {
        menus: [...menus],
        isDeleting: false,
        idToDelete: null,
        menusMessage: 'Menu has been Deleted!',
      });
    },
    DELETING_MENU(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async copyMenuRequest({dispatch}, payload) {
      dispatch("receivingMenu");
      console.log(payload)
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/copy/menu/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers})
      .then((response)=> {
        dispatch("receiveMenu", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    deleteMenuRequest({dispatch}, payload) {
      dispatch("deletingMenu", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/menu/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteMenu", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteMenuGroupRequest({dispatch}, payload) {
      try{
        dispatch("deletingMenu", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/menugroup/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteMenuSubgroupRequest({dispatch}, payload) {
      try{
        dispatch("deletingMenu", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/menusubgroup/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteMenuItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingMenu", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/menuitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMenusRequest({dispatch}) {
      dispatch("receivingMenus");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/menus';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveMenus", res.data);
      })
    },
    async insertMenuRequest({dispatch}, payload) {
      dispatch("receivingMenu");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/menu';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveMenu", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertMenuItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/menuitem/' + payload.menuid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMenuGroupRequest({dispatch}, payload) {
      try{
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/menugroup/' + payload.menuid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMenuSubgroupRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/menusubgroup/' + payload.menuid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateMenuRequest({dispatch}, payload) {
      dispatch("updatingMenu");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/menu/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateMenu", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateMenuItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/menuitem/' + payload.menuitemid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMenuGroupRequest({dispatch}, payload) {
      try{
        console.log(payload)
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/menugroup/' + payload.menugroupid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMenuSubgroupRequest({dispatch}, payload) {
      try{
        console.log(payload)
        dispatch("receivingMenu");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/menusubgroup/' + payload.menusubgroupid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveMenu", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveMenus({commit}, payload) {
      commit("RECEIVED_MENUS", payload)
    },
    receivingMenus({commit}) {
      commit("RECEIVING_MENUS")
    },
    receiveMenu({commit}, payload) {
      commit("RECEIVED_MENU", payload)
    },
    receivingMenu({commit}) {
      commit("RECEIVING_MENU")
    },
    updateMenu({commit}, payload) {
      commit("UPDATED_MENU", payload)
    },
    updatingMenu({commit}) {
      commit("UPDATING_MENU")
    },
    deleteMenu({commit}, payload) {
      commit("DELETED_MENU", payload)
    },
    deletingMenu({commit}, payload) {
      commit("DELETING_MENU", payload)
    }
  },
};
